import React from 'react'

function DashInComp() {
  return (
    <div className='instructorComponent'>
        DashInComp
    </div>
  )
}

export default DashInComp